<div [formGroup]="formGroup()" class="time-range-field">
  <umss-checkbox label="All day" size="Regular" formControlName="allDay" />

  @if (!formGroup().controls['allDay'].value) {
    <div smoothCollapse class="time-fields">
      <umss-horizontal-field
        label="Start time"
        htmlFor="startTime-field"
        [error]="showStartError()"
        [required]="true"
      >
        <div>
          <umss-input
            id="startTime-field"
            type="text"
            placeholder="00:00"
            size="Regular"
            [mask]="'Hh:m0'"
            [error]="showStartError()"
            formControlName="startTime"
          />
          @if (showStartError()) {
            <p class="error-message">
              @if (startTimeErrors()?.has('required')) {
                This field is required
              }
              @if (startTimeErrors()?.has('hhmm')) {
                Invalid time format. Use HH:mm (e.g. 09:30).
              }
            </p>
          }
        </div>
      </umss-horizontal-field>

      <umss-horizontal-field
        label="End time"
        htmlFor="endTime-field"
        [error]="showEndError()"
        [required]="true"
      >
        <div>
          <umss-input
            id="endTime-field"
            type="text"
            placeholder="23:59"
            size="Regular"
            [mask]="'Hh:m0'"
            [error]="showEndError()"
            formControlName="endTime"
          />
          @if (showEndError()) {
            <p class="error-message">
              @if (endTimeErrors()?.has('required')) {
                This field is required
              }
              @if (endTimeErrors()?.has('hhmm')) {
                Invalid time format. Use HH:mm (e.g. 09:30).
              }
            </p>
          }
        </div>
      </umss-horizontal-field>

      @if (formGroup().errors?.['timeRange']) {
        <p class="error-message">Start time must be earlier than end time.</p>
      }
      @if (formGroup().errors?.['sameTime']) {
        <p class="error-message">Start and end time cannot be the same.</p>
      }
    </div>
  }
</div>
